module.exports = __webpack_public_path__ + "static/media/Vector2.b7b72ee2.png";